import { getJrnDefaultComponent } from '../getJrn/getJrnDefaultComponent.js'
import getHoldMusicController from './getHoldMusicController.js'
import _module from 'module.js'
import _ from 'lodash'

let getHoldMusicComponent = _.cloneDeep(getJrnDefaultComponent)
getHoldMusicComponent.controller = getHoldMusicController

_module.component('getHoldMusic', getHoldMusicComponent)
